﻿import { selectDateRange } from './functions';

export function GetCompanyList(query, index) {
    $.ajax({
        method: "GET",
        url: Router.action("UserAccess", "BrowseCompaniesTable"),
        data: { query: query, pageIndex: index },
        success: function (data) {
            $(".browse-companies-table").html(data);
        }
    });
}


export function GetTutorialsList(query, index) {
    $.ajax({
        method: "GET",
        url: Router.action("UserAccess", "BrowseTutorialsTable"),
        data: { query: query, pageIndex: index },
        success: function (data) {
            $(".browse-companies-table").html(data);
        }
    });
}

export function GetReportTempaltesList(query, index) {
    $.ajax({
        method: "GET",
        url: Router.action("UserAccess", "BrowseTemplatesTable"),
        data: { query: query, pageIndex: index },
        success: function (data) {
            $(".browse-report-templates-table").html(data);
        }
    });
}

export function GetShareDailyPrice(id, index) {
    $.ajax({
        method: "GET",
        url: Router.action("Asset", "SharesGetDailyPage"),
        data: { ShareId: id, pageIndex: index, AssetType: 1 },
        success: function (data) {
            $(".share-daily-prices").html(data);
        }
    });
}

export function GetShareMonthlyPrice(id, index) {
    $.ajax({
        method: "GET",
        url: Router.action("Asset", "SharesGetMonthlyPage"),
        data: { ShareId: id, pageIndex: index, AssetType: 1 },
        success: function (data) {
            $(".share-monthly-prices").html(data);
        }
    });
}

export function GetCurrencyDailyPrice(id, index) {
    $.ajax({
        method: "GET",
        url: Router.action("Asset", "CurrenciesGetDailyPage"),
        data: { CurrencyId: id, pageIndex: index, AssetType: 0 },
        success: function (data) {
            $(".fx-daily-prices").html(data);
        }
    });
}

export function GetCurrencyMonthlyPrice(id, index) {
    $.ajax({
        method: "GET",
        url: Router.action("Asset", "CurrenciesGetMonthlyPage"),
        data: { CurrencyId: id, pageIndex: index, AssetType: 0 },
        success: function (data) {
            $(".fx-monthly-prices").html(data);
        }
    });
}

export function ProcessAssetUpdate(Assets, AssetType, url, i, callback) {
    if (i < Assets.length) {
        $("#body-status-message").html("Building " + Assets[i] + "<br />(" + (i + 1) + " of " + Assets.length + ")<br /><span id=\"init-status\">.  </span><div class=\"progress\"> <div class=\"progress-bar progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"45\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: " + ((i / Assets.length) * 100) + "%\"> <span class=\"\">" + Number(((i / Assets.length) * 100).toFixed(2)) + "%</span> </div> </div>");

        var seconds = 1;
        var interval = setInterval(function () {
            var part = seconds++ % 3;
            var stat = (part == 0) ? ".  " : ((part == 1) ? ".. " : "...");
            $("#init-status").html(stat);
        }, 1000);
        $.ajax({
            method: "POST",
            url: url,
            data: { Ticker: Assets[i], Overwrite: true, AssetType: AssetType },
            success: function (data) {
                clearInterval(interval);
                $("#init-status").html("Done");
                setTimeout(function () {
                    ProcessAssetUpdate(Assets, AssetType, url, i + 1, callback);
                }, 1000);
            },
            complete: function (e) {
                if (!(e.status === 500 || e.status == 200)) {
                    $("#init-status").html("Failed");
                    clearInterval(interval);
                    setTimeout(function () {
                        ProcessAssetUpdate(Assets, AssetType, url, i + 1, callback);
                    }, 1000);
                }
            },
            statusCode: {
                500: function () {
                    clearInterval(interval);
                    $("#init-status").html("Failed");
                    setTimeout(function () {
                        ProcessAssetUpdate(Assets, AssetType, url, i + 1, callback);
                    }, 1000);
                }
            }
        });
    } else {
        callback();
    }
}

export function buildAssetList(filter) {
    //var filter = $(this).val().toLowerCase();
    $("#AssetId").find("option").remove();
    if (filter == null || filter == "") {
        var test = $("#asset-ticker-array").html();
        $("#AssetId").html($("#asset-ticker-array").html());
    } else {
        $("#asset-ticker-array option").each(function () {
            var text = $(this).text().toLowerCase();
            if (text == "" || text.indexOf(filter) >= 0) {
                $(this).clone().appendTo("#AssetId");
            }
        });
    }
}

export function GetPeriodicAssetPrices() {
    var type = $('.asset-type').val();
    var id = $('#AssetId').val();
    if(id > 0) {
        if(type == 0) {
            GetCurrencyDailyPrice($('#AssetId').val());
            GetCurrencyMonthlyPrice($('#AssetId').val());
        } else if(type == 1) {
            GetShareDailyPrice($('#AssetId').val());
            GetShareMonthlyPrice($('#AssetId').val());
        } else {
            return;
        }

        selectDateRange("#asset-startdate", "#asset-enddate");
        buildAssetList();
    }
}